/*
* Response from device shadow
* {
    Alarm,
    Thermostat,
    InputOutput,
    Timer,
    Redundancy
};
*
* In frontend
* {
* Input
* Timer
* Thermostat
* }
* */

export const getRelayWorkType = (workType: number) => {
    if (workType === 1) {
        return 2;
    } else if (workType === 3) {
        return 1;
    } else if (workType === 5) {
        return 3;
    }
    return 0;
}

export const getRelayTriggerSource = (triggerSource: number, workType: number) => {
    if (workType === 0 && triggerSource < 6) {
        return triggerSource;
    } else if (workType === 2 && triggerSource > 5 && triggerSource < 12) {
        return triggerSource - 6;
    } else if (triggerSource > 5 && triggerSource < 12) {
        return triggerSource - 6;
    } else if (workType === 4) {
        return 12;
    }
    return 13;
}

export const getShadowRelayWorkType = (workType: number) => {
    if (workType === 2) {
        return 1;
    } else if (workType === 1) {
        return 3;
    } else if (workType === 3) {
        return 5;
    }
    return 2;
}

export const getShadowTriggerSource = (triggerSource: number, workType: number) => {
    if (workType === 0) {
        return triggerSource;
    } else if (workType === 2) {
        return triggerSource + 6;
    } else if (workType === 3) {
        return  12;
    }
    return 13;
}